export const locales = [
  "ar", // Arabic
  "de", // German
  "el", // Greek
  "en", // English
  "es", // Spanish
  "fi", // Finnish
  "fr", // French
  "hi", // Hindi
  "id", // Indonesian
  "it", // Italian
  "ja", // Japanese
  "ko", // Korean
  "ms", // Malay
  "nl", // Dutch
  "pl", // Polish
  "pt", // Portuguese
  "ru", // Russian
  "sv", // Swedish
  "th", // Thai
  "tr", // Turkish
  "uk", // Ukrainian
  "vi", // Vietnamese
  "zh", // Chinese
] as const;
export type Locale = (typeof locales)[number];
export const defaultLocale = "en" as Locale;

export const localeNames = {
  ar: { name: "AR", flag: "🇸🇦" },
  de: { name: "DE", flag: "🇩🇪" },
  el: { name: "EL", flag: "🇬🇷" },
  en: { name: "EN", flag: "🇺🇸" },
  es: { name: "ES", flag: "🇪🇸" },
  fi: { name: "FI", flag: "🇫🇮" },
  fr: { name: "FR", flag: "🇫🇷" },
  hi: { name: "HI", flag: "🇮🇳" },
  id: { name: "ID", flag: "🇮🇩" },
  it: { name: "IT", flag: "🇮🇹" },
  ja: { name: "JA", flag: "🇯🇵" },
  ko: { name: "KO", flag: "🇰🇷" },
  ms: { name: "MS", flag: "🇲🇾" },
  nl: { name: "NL", flag: "🇳🇱" },
  pl: { name: "PL", flag: "🇵🇱" },
  pt: { name: "PT", flag: "🇵🇹" },
  ru: { name: "RU", flag: "🇷🇺" },
  sv: { name: "SV", flag: "🇸🇪" },
  th: { name: "TH", flag: "🇹🇭" },
  tr: { name: "TR", flag: "🇹🇷" },
  uk: { name: "UK", flag: "🇺🇦" },
  vi: { name: "VI", flag: "🇻🇳" },
  zh: { name: "ZH", flag: "🇨🇳" },
} as const;

export function isValidLocale(locale: string): locale is Locale {
  return locales.includes(locale as Locale);
}
